module.exports = __webpack_public_path__ + "static/media/Frog-web-logo.ef99b6bf.png";